import { HTMLAttributes, useState } from 'react'
import {
  BottomSheet,
  BottomSheetCloseButton,
  BottomSheetContent,
  BottomSheetHeader,
  BottomSheetTitle,
} from 'components/ui/BottomSheet'
import { useAsyncEffect, useDisclosure } from '@dwarvesf/react-hooks'
import { useTranslations } from 'next-intl'
import { IconSpinner } from 'components/icons/components/IconSpinner'
import dynamic from 'next/dynamic'
import { LOCALE } from 'constants/dev'

interface Props extends HTMLAttributes<HTMLButtonElement> {
  title?: string
  content?: string
}

export function TermPolicyViewTrigger(props: Props) {
  const t = useTranslations()
  const {
    className = 'text-primary font-semibold',
    title = t('terms_and_conditions'),
    content = 'TermsAndConditions',
    onClick,
    ...rest
  } = props
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [Component, setComponent] = useState<React.ComponentType<{}>>()

  useAsyncEffect(async () => {
    if (isOpen && !Component) {
      try {
        const response = await dynamic(
          import(`components/profile/policies/${LOCALE}/${content}`),
        )
        setTimeout(() => {
          setComponent(response)
        }, 500)
      } catch (error) {
        console.error(error)
      }
    }
  }, [isOpen, Component])

  return (
    <>
      <button
        className={className}
        {...rest}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          onOpen()
        }}
      />
      <BottomSheet isOpen={isOpen} onClose={onClose}>
        <BottomSheetHeader>
          <BottomSheetTitle className="text-center whitespace-nowrap">
            {title}
          </BottomSheetTitle>
          <BottomSheetCloseButton />
        </BottomSheetHeader>
        <BottomSheetContent>
          <div className="content-entry">
            {!Component ? (
              <IconSpinner className="w-6 h-6 text-primary absolute center-x center-y" />
            ) : (
              <Component />
            )}
          </div>
        </BottomSheetContent>
      </BottomSheet>
    </>
  )
}
